export enum ModalTypes {
  CANDIDATE_INFORMATION,
  TEST_MESSAGE_MODAL,
  EQUALITY_AND_DIVERSITY_MODAL,
  NOTIFICATION_MODAL,
}
